import { inject as g, ref as H, watchEffect as O } from "vue";
import { useSsrAdapter as S } from "./ghl-ui.es694.js";
import { configProviderInjectionKey as $ } from "./ghl-ui.es984.js";
import { c as R } from "./ghl-ui.es669.js";
import { throwError as _ } from "./ghl-ui.es899.js";
import h from "./ghl-ui.es986.js";
function E(v, o, i, p) {
  var s;
  i || _("useThemeClass", "cssVarsRef is not passed");
  const t = (s = g($, null)) === null || s === void 0 ? void 0 : s.mergedThemeHashRef, n = H(""), y = S();
  let r;
  const C = `__${v}`, T = () => {
    let e = C;
    const m = o ? o.value : void 0, l = t == null ? void 0 : t.value;
    l && (e += "-" + l), m && (e += "-" + m);
    const {
      themeOverrides: a,
      builtinThemeOverrides: f
    } = p;
    a && (e += "-" + h(JSON.stringify(a))), f && (e += "-" + h(JSON.stringify(f))), n.value = e, r = () => {
      const d = i.value;
      let u = "";
      for (const c in d)
        u += `${c}: ${d[c]};`;
      R(`.${e}`, u).mount({
        id: e,
        ssr: y
      }), r = void 0;
    };
  };
  return O(() => {
    T();
  }), {
    themeClass: n,
    onRender: () => {
      r == null || r();
    }
  };
}
export {
  E as useThemeClass
};
